module.exports = __webpack_public_path__ + "img/e4e3c23.webp";